import React, { useContext, useEffect } from "react";
import { message, Popconfirm, Space } from "antd";
import { FormattedMessage, injectIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocalVideo, useToggleLocalMute } from "amazon-chime-sdk-component-library-react";
import { withTheme } from "styled-components";

import MeetingContext from "../MeetingContext";
import MeetingControl from "./meetingControl";

const MESSAGEDURATION = 1;

const CallButtons = withTheme(
  injectIntl(({ hideEndCall = false, intl, manager, visible = true }) => {
    const { cleanUpMeeting, fullscreen, resetComponent, setWasToggled, wasToggled } = useContext(MeetingContext);
    const { isVideoEnabled, toggleVideo } = useLocalVideo();
    const { muted, toggleMute } = useToggleLocalMute();

    useEffect(() => {
      if (wasToggled) {
        if (!isVideoEnabled) {
          toggleVideo();
          setWasToggled(false);
        }
      }
    });

    const microPhoneValues = {
      icon: muted ? "microphone-slash" : "microphone",
      text: muted ? "Microphone On" : "Microphone Off",
      iconColor: muted ? null : "white",
      buttonType: muted ? "danger" : "ghost",
    };

    const videoValues = {
      icon: isVideoEnabled ? "video" : "video-slash",
      text: isVideoEnabled ? "Camera Off" : "Camera On",
      iconColor: isVideoEnabled ? "white" : null,
      buttonType: isVideoEnabled ? "ghost" : "danger",
    };

    const toggleItem = ({ duration, icon = ["fal", "phone"], text = "Turned off" }) => {
      message.info({
        content: ` ${intl.formatMessage({ id: text })}`,
        duration: duration ?? MESSAGEDURATION,
        icon: <FontAwesomeIcon icon={icon} />,
      });
    };

    return (
      <Space size={fullscreen ? 40 : 22} hidden={!visible}>
        <MeetingControl
          buttonText={{ icon: ["fal", microPhoneValues?.icon], color: microPhoneValues?.iconColor }}
          onClick={() => {
            toggleMute();
            toggleItem({
              text: microPhoneValues?.text,
              icon: ["fal", microPhoneValues?.icon],
            });
          }}
          title={`Turn ${microPhoneValues?.text ?? ""}`}
          type={microPhoneValues?.buttonType}
        />
        <MeetingControl
          buttonText={{ icon: ["fal", videoValues?.icon], color: videoValues?.iconColor }}
          onClick={() => {
            toggleVideo();
            toggleItem({
              text: videoValues?.text,
              icon: ["fal", videoValues?.icon],
            });
          }}
          placement="topRight"
          title={`Turn ${videoValues?.text ?? ""}`}
          type={videoValues?.buttonType}
        />
        <Popconfirm
          title={<FormattedMessage id="Are you sure you want to end you call?" />}
          centered
          onConfirm={() => {
            manager.leave();
            resetComponent();
            cleanUpMeeting();
          }}
        >
          <MeetingControl
            visible={!hideEndCall}
            buttonText={{ icon: ["fal", "phone"], color: "red", size: "2x", transform: { rotate: 225 } }}
            placement="topRight"
            title="End Meeting"
            type="link"
          />
        </Popconfirm>
      </Space>
    );
  })
);

export default CallButtons;
